import { LotAddendumIncentiveApplicationMethod } from '../enums/dsm-asp-incentives.enums';
import { DsmContractSelection } from './dsm-contract-details.models';
import { DsmAddendumProductPayload } from './dsm-deal-options.models';
import { DiscountType } from './dsm-deal-options-view.models';
import { DsmApplyAddendumIncentivePayload } from './dsm-lot-incentives.models';

export interface DsmSelectionBasketOptionPayload extends DsmAddendumProductPayload {
  optionKey: string;
  discountTypeId: DiscountType | null;
  discountValue: number | null;
}

export interface DsmSelectionBasketSavePayload {
  addendumId?: string;
  builderReferenceId?: string;
  lotId?: string;
  dealId?: string;
  options: DsmSelectionBasketOptionPayload[];
  discountPercentage?: number;
  incentive?: DsmApplyAddendumIncentivePayload;
}

export interface DsmSelectionBasketOptionResult {
  optionKey: string;
  added: boolean;
  addendumProductId: string | null;
  error: string | null;
}

export interface DsmSelectionBasketSaveResult {
  addendumId: string | null;
  addendumCreated: boolean;
  addedCount: number;
  failedCount: number;
  options: DsmSelectionBasketOptionResult[];
}

export interface DsmOptionTax {
  taxAuthorityId: string;
  code: string;
  name: string | null;
  // null only when summed over options charging this authority different rates
  rate: number | null;
  amount: number;
}

export interface DsmSelectionBasketOptionPreview {
  optionKey: string;
  added: boolean;
  error: string | null;
  amount: number;
  discount: number;
  taxes: DsmOptionTax[];
  taxesTotal: number;
  incentiveAmount: number;
  total: number;
  linkedProducts: DsmSelectionBasketOptionPreview[];
}

// The response also carries the addendum's totals, left out here: for an existing addendum they include its
// saved options, so the basket's own figures are summed from its options instead.
export interface DsmSelectionBasketPreview {
  addendumId: string | null;
  addendumCreated: boolean;
  addedCount: number;
  failedCount: number;
  options: DsmSelectionBasketOptionPreview[];
}

export interface DsmSelectionBasketAdjustments {
  incentive: number;
  incentiveMethod: LotAddendumIncentiveApplicationMethod;
  discountPercentage: number;
}

export const DSM_SELECTION_BASKET_NO_ADJUSTMENTS: DsmSelectionBasketAdjustments = {
  incentive: 0,
  incentiveMethod: LotAddendumIncentiveApplicationMethod['Highest cost first'],
  discountPercentage: 0
};

export interface DsmSelectionBasket {
  selections: DsmContractSelection[];
  adjustments: DsmSelectionBasketAdjustments;
}
